import { render, staticRenderFns } from "./KnowledgeFilter.vue?vue&type=template&id=5a062ee3&scoped=true&"
import script from "./KnowledgeFilter.vue?vue&type=script&lang=js&"
export * from "./KnowledgeFilter.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeFilter.vue?vue&type=style&index=0&id=5a062ee3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a062ee3",
  null
  
)

export default component.exports